import script from "./EditAdminTireModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditAdminTireModal.vue?vue&type=script&setup=true&lang=ts"

import "./EditAdminTireModal.vue?vue&type=style&index=0&id=39d6603c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d6603c"]])

export default __exports__